import { Link } from "react-router-dom";

const Terms = () => {
  return (
    <div className="w-full" data-testid="terms-page">
      <section className="bg-gradient-to-r from-blue-600 via-purple-600 to-orange-500 text-white py-16 md:py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-4" data-testid="terms-hero-title">Terms & Conditions</h1>
          <p className="text-lg text-white/90">The terms governing our services and your use of this website</p>
        </div>
      </section>

      <section className="py-12 md:py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 prose prose-lg max-w-none">
          <p className="text-gray-600 mb-8 text-sm">Last updated: January 2026</p>

          <h2 className="text-2xl font-bold text-gray-900 mb-4">1. About Us</h2>
          <p className="text-gray-700 mb-6 leading-relaxed">
            Maruns Limited is a company registered in England and Wales under Company Number 16749241. Our registered office is at Innovation Centre and Business Base, 110 Butterfield, Great Marlings, Luton, LU2 8DL, United Kingdom. These Terms and Conditions ("Terms") govern your use of our website and the logistics and transport services we provide.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mb-4">2. Acceptance of Terms</h2>
          <p className="text-gray-700 mb-6 leading-relaxed">
            By using our website or engaging our services, you agree to be bound by these Terms. If you do not agree, please do not use our website or services.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mb-4">3. Our Services</h2>
          <p className="text-gray-700 mb-3 leading-relaxed">Maruns Limited provides transport, logistics, moving, and clearance services including but not limited to:</p>
          <ul className="list-disc pl-6 text-gray-700 mb-6 space-y-2">
            <li>Residential and commercial moving and relocation</li>
            <li>Office and business logistics</li>
            <li>Packing, storage, and furniture assembly</li>
            <li>Food and catering logistics</li>
            <li>Light clearance and removal support</li>
            <li>Technology and equipment transport</li>
            <li>Daily supply and distribution services</li>
          </ul>

          <h2 className="text-2xl font-bold text-gray-900 mb-4">4. Quotations and Pricing</h2>
          <p className="text-gray-700 mb-6 leading-relaxed">
            All quotations are provided based on information supplied by the client. Prices may vary if the actual requirements differ from those described at the time of quotation. Quotations are valid for 14 days unless otherwise stated. All prices are quoted in GBP and are exclusive of VAT unless stated otherwise.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Bookings and Cancellations</h2>
          <p className="text-gray-700 mb-6 leading-relaxed">
            Bookings are confirmed upon receipt of written or verbal confirmation from the client. Cancellations made with less than 48 hours' notice may be subject to a cancellation charge. We reserve the right to cancel or reschedule services due to circumstances beyond our control, in which case a full refund or alternative date will be offered.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Client Responsibilities</h2>
          <p className="text-gray-700 mb-3 leading-relaxed">Clients are responsible for:</p>
          <ul className="list-disc pl-6 text-gray-700 mb-6 space-y-2">
            <li>Providing accurate and complete information about the items to be moved or services required</li>
            <li>Ensuring safe and legal access to collection and delivery locations</li>
            <li>Declaring any items of exceptional value, fragility, or hazardous nature</li>
            <li>Securing any necessary permits (e.g., parking permits for loading/unloading)</li>
          </ul>

          <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Insurance and Liability</h2>
          <p className="text-gray-700 mb-6 leading-relaxed">
            Maruns Limited carries goods-in-transit insurance and public liability insurance. Our liability for loss or damage to goods is limited to the terms of our insurance policy. We are not liable for loss or damage caused by circumstances beyond our reasonable control, including but not limited to: acts of God, fire, flood, severe weather, or third-party negligence. Clients are advised to arrange their own additional insurance for items of high value.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mb-4">8. Payment Terms</h2>
          <p className="text-gray-700 mb-6 leading-relaxed">
            Payment is due as agreed at the time of booking. For residential services, payment is typically required upon completion of the service. For commercial and recurring services, invoices are issued with payment due within 14 days unless otherwise agreed. We reserve the right to charge interest on overdue payments in accordance with the Late Payment of Commercial Debts (Interest) Act 1998.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mb-4">9. Complaints</h2>
          <p className="text-gray-700 mb-6 leading-relaxed">
            If you are dissatisfied with any aspect of our service, please contact us within 7 days of service delivery. We will investigate all complaints promptly and aim to resolve them within 14 working days. Complaints should be directed to <a href="mailto:marunsltd@outlook.com" className="text-blue-600 hover:underline">marunsltd@outlook.com</a>.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mb-4">10. Intellectual Property</h2>
          <p className="text-gray-700 mb-6 leading-relaxed">
            All content on this website, including text, images, logos, and design, is the property of Maruns Limited and is protected by copyright and other intellectual property laws. You may not reproduce, distribute, or use any content without our prior written consent.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mb-4">11. Website Use</h2>
          <p className="text-gray-700 mb-6 leading-relaxed">
            This website is provided for informational purposes and to facilitate service enquiries. We make reasonable efforts to ensure the information on our website is accurate and up to date, but we do not guarantee its completeness or accuracy. We reserve the right to modify or discontinue the website at any time without notice.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mb-4">12. Third-Party Links</h2>
          <p className="text-gray-700 mb-6 leading-relaxed">
            Our website may contain links to third-party websites. We are not responsible for the content or privacy practices of these external sites.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mb-4">13. Governing Law</h2>
          <p className="text-gray-700 mb-6 leading-relaxed">
            These Terms are governed by the laws of England and Wales. Any disputes arising from these Terms or our services shall be subject to the exclusive jurisdiction of the courts of England and Wales.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mb-4">14. Changes to These Terms</h2>
          <p className="text-gray-700 mb-6 leading-relaxed">
            We may update these Terms from time to time. Continued use of our website or services after any changes constitutes acceptance of the revised Terms.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mb-4">15. Contact Us</h2>
          <div className="bg-gray-50 p-6 rounded-lg border border-gray-200 mb-8">
            <p className="text-gray-700"><strong>Maruns Limited</strong></p>
            <p className="text-gray-700">Innovation Centre and Business Base, 110 Butterfield, Great Marlings</p>
            <p className="text-gray-700">Luton, LU2 8DL, United Kingdom</p>
            <p className="text-gray-700">Company Number: 16749241</p>
            <p className="text-gray-700">Email: <a href="mailto:marunsltd@outlook.com" className="text-blue-600 hover:underline">marunsltd@outlook.com</a></p>
            <p className="text-gray-700">Phone: <a href="tel:+447405747177" className="text-blue-600 hover:underline">+44 7405 747177</a></p>
          </div>

          <div className="text-center mt-12">
            <Link to="/" className="text-blue-600 hover:underline font-semibold" data-testid="terms-back-home">Back to Home</Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Terms;
